import { rankWith, uiTypeIs } from '@jsonforms/core';

export default rankWith(
  3,
  uiTypeIs("IFrameControl")
);